const postGroupsStr = {
  postGroups: 'Grupo adicionado',
  postGroups1: ' foi adicionado com sucesso',
  toastrError: 'Nome já cadastrado',
  toastrError1: 'Insira outro nome'
};

export default postGroupsStr;
